angular
  .module("erp.other.newsandtrendsDetail", ["ui.router", "newsandtrendsDetail.service"])
  .config([
    "$stateProvider",
    "$httpProvider",
    function($stateProvider, $httpProvider) {
      $httpProvider.defaults.headers.put["Content-Type"] = "application/json;charset=utf-8";
      $stateProvider.state("newsandtrendsDetail", {
        url: "/erp/other/newsandtrendsDetail",
        templateUrl: "tpl/outbox.htm",
        controllerAs: "vm",
        controller: "baseCtrl",
        resolve: {},
      });
    },
  ])

  .controller("baseCtrl", [
    "$scope",
    "$http",
    "$sce",
    "$q",
    "kit",
    "$state",
    "$timeout",
    "$window",
    function($scope, $http, $sce, $q, kit, $state, $timeout, $window) {
        var vm = this;
        vm.tpl = "tpl/outbox.htm";
        vm.openURL = function (url) {
            window.open(url, '_blank');
        };
        vm.recommendations = [];
        vm.posts = [];

        // 获取标签
        vm.getTag = function () {
          $http.get('/newInformation/get/tag').success( function(res){
            vm.tags = res.data.list;
            if (!vm.searchtest) {
              return;
            }
            vm.tags.forEach( function(item) {
              if (item.id == vm.searchtest.test) {
                vm.searchtest.test = item.name;
              }
            });
          });
        };
        vm.getTag();

        vm.status = "1";

        vm.opensearchTag = function (id, item) {
          window.open('/erp/newsandtrends/tag/' + id + '-' + item.name, '_blank');
        };

        vm.searchTag = function (tag) {
            vm.searchtest = {
                test: tag
            };
            vm.detailedArticle='';
            vm.tagId = tag;
            vm.chooseStatus();
        };

        vm.chooseStatus = function(val) {
            vm.status = val;
            vm.listlimitpage = 1;
            vm.recommendlistlimitpage = 1;
            // vm.recommendations = [];
            vm.posts = [];
            vm.next(0);
            // vm.next(1);
        };
        vm.openDetailsURL = function (id, item) {
          if (item.url) {
            vm.openURL(item.url);
          }
          window.open('/erp/newsandtrends/detail/' + id, '_blank');
        };

        vm.openDetails = function (id) {
          $http.get('/newInformation/detail?id=' + id).success(function (res) {
            if (res.success) {
              if (!res.data || !res.data.detail) {
                return;
              }
              if (res.data.detail.url) {
                vm.openURL(res.data.detail.url);
              }
              vm.detailedArticle = res.data.detail;

              // 标记内容为安全的 HTML
              vm.trustedContent = $sce.trustAsHtml(vm.detailedArticle.content);

              // 使用 DOM 操作处理 img 标签的 alt 属性
              var parser = new DOMParser();
              var doc = parser.parseFromString(vm.detailedArticle.content, 'text/html');
              var imgTags = doc.querySelectorAll('img');

              imgTags.forEach(function(img) {
                  if (!img.hasAttribute('alt')) {
                      img.setAttribute('alt', '芒果店长');
                  }
              });

              // 更新 vm.detailedArticle.content
              vm.detailedArticle.content = doc.body.innerHTML;

              // 标记更新后的内容为安全的 HTML
              vm.trustedContent = $sce.trustAsHtml(vm.detailedArticle.content);


              // 使用正则表达式提取 <strong> 标签内的内容
              var strongTexts = [];
              var regex = /<strong>(.*?)<\/strong>/g;
              var match;
              while ((match = regex.exec(vm.detailedArticle.content)) !== null) {
                  strongTexts.push(match[1].trim());
              }

              // 汇总文字
              vm.strongSummary = strongTexts.join(', ');
            } else {
              vm.box = { type: 'danger', msg: res.msg };
            }
          });
        };
        
        // 监听视图内容加载完成事件
        $scope.init = function() {
          vm.generateQRCode();
        };

        vm._next = true;

        // 懒加载
        vm.listlimitpage = 1;
        vm.recommendlistlimitpage = 1;
        vm.next = function(recommendtype) {
          vm.box = {
              type: 'loading'
          };
          var postdata = {
              page: recommendtype === 0 ? vm.listlimitpage : vm.recommendlistlimitpage,
              pageSize: recommendtype === 0 ? 30 : 1000,
              type:vm.status,
              recommend: recommendtype,
          };
          if (recommendtype === 0) {
            delete postdata.recommend;
            if (vm.tagId) {
              postdata.tagId = vm.tagId;
            }
          }
          if (recommendtype === 1) {
            delete postdata.type;
          }
          $http.post('/newInformation/page', JSON.stringify(postdata), { headers: { 'Content-Type': 'application/json' } }).success(function (res) {
              vm.box = { type: 'close' };
              if (res.success) {
                if (recommendtype === 0) {
                  vm.posts.push.apply(vm.posts, res.data.list); // 合并代码
                  if (vm.searchtest) {
                    vm.searchtest.num = res.data.total;
                  }
                } else {
                  vm.recommendations.push.apply(vm.recommendations, res.data.list); // 合并代码
                  if (vm.recommendations.length>4) {
                    $timeout(function() {
                      vm.autoScroll();
                    }, 0);
                  }
                }
              } else {
                  vm.box = { type: 'danger', msg: res.msg };
              }
          });
        };

        var path = location.search || location.href;
        // 分割路径并取最后一部分
        var segments = path.split("/");
        var lastSegment = segments[segments.length - 1]; 

        // 提取数字部分
        // var tagId = lastSegment.split("-"); 

        // 带id
        vm.openDetails(lastSegment);
        // vm.searchTag(params.tag);
        // vm.next(0);
        vm.next(1);

        vm.handleScroll = function() {
          if (vm.listlimitpage * 30 <= vm.posts.length) {
            vm.listlimitpage++;
            vm.next(0);
          }
        };
        vm.handleScrollrecommendation= function() {
          if (vm.recommendlistlimitpage * 1000 <= vm.recommendations.length) {
            vm.recommendlistlimitpage++;
            vm.next(1);
          }
        };
        // 自动滚动和鼠标悬停停止

        vm.autoScroll = function() {
          // 容器元素获取
          var container = document.querySelector('.popular-recommendations-newsand-ul');
          if (!container) {return;}

          // 内容元素处理
          var ul = container.querySelector('ul');
          if (!ul || ul.children.length < 2) {return;}

          // 检查 ul 的高度是否小于 250
          if (ul.offsetHeight < 250) {
            // 在这里添加你想要执行的操作
            return; // 如果需要在高度小于 250 时停止执行后续代码，可以在这里返回
          }

          // 克隆节点实现无缝滚动
          var createClone = function() {
            var clone = ul.cloneNode(true);
            clone.style.position = 'absolute';
            clone.style.top = 0;
            container.appendChild(clone);
            return clone;
          };
          var clone = createClone();

          // 硬件加速优化
          var applyTransform = function(element, y) {
            element.style.transform = 'translate3d(0, ' + y + 'px, 0)';
          };

          // 动画控制变量
          var translateY = 0;
          var timer = null;
          var lastUpdate = Date.now();
          var baseSpeed = 30; // px/s
          var isPaused = false;
          var currentSpeed = baseSpeed;

          // 核心动画逻辑
          var animate = function() {
            if (isPaused) {return;}

            var now = Date.now();
            var deltaTime = (now - lastUpdate) / 1000;
            lastUpdate = now;

            // 动态速度补偿算法
            var targetDelta = 1 / 60; // 基准帧时间
            var speedFactor = Math.min(deltaTime / targetDelta, 2.5);
            currentSpeed = baseSpeed * speedFactor;

            // 计算滚动位移
            var containerHeight = container.offsetHeight;
            var contentHeight = ul.offsetHeight;

            translateY -= currentSpeed * deltaTime;

            // 无缝滚动逻辑
            if (-translateY >= contentHeight) {
               // 重置 translateY 并重新设置克隆节点的位置
              translateY = 0;
              applyTransform(ul, translateY);
              applyTransform(clone, translateY + contentHeight);
            }


            // 应用双重动画
            applyTransform(ul, translateY);
            applyTransform(clone, translateY + contentHeight);

            // 精确帧率控制
            var elapsed = Date.now() - now;
            var delay = Math.max(0, 1000/60 - elapsed);
            timer = setTimeout(animate, delay);
          };

          // 事件处理（被动监听优化）
          var handleInteraction = function(type) {
            if (type === 'enter') {
              isPaused = true;
              ul.style.transition = 'transform 0.4s cubic-bezier(0.25,0.1,0.25,1)';
              clone.style.transition = 'transform 0.4s cubic-bezier(0.25,0.1,0.25,1)';
            } else {
              isPaused = false;
              lastUpdate = Date.now();
              ul.style.transition = 'none';
              clone.style.transition = 'none';
              animate();
            }
          };

          // 事件监听（兼容处理）
          var eventOpts = { passive: true };
          container.addEventListener('mouseenter', function() {
            handleInteraction('enter');
          }, eventOpts);
          container.addEventListener('mouseleave', function() {
            handleInteraction('leave');
          }, eventOpts);

          // 启动动画
          animate();

          // 内存管理
          var cleanup = function() {
            clearTimeout(timer);
            container.removeEventListener('mouseenter', handleInteraction);
            container.removeEventListener('mouseleave', handleInteraction);
            if (clone.parentNode) {
              clone.parentNode.removeChild(clone);
            }
            ul.style.transform = '';
          };

          // 销毁处理
          $scope.$on('$destroy', cleanup);
          $scope.$on('$locationChangeStart', cleanup);
        };

        // 生成二维码的函数
        vm.generateQRCode = function() {
          vm.qrcode = new QRCode(document.getElementById("qrcode"), {
              text: window.location.href,
              width: 128,
              height: 128,
              colorDark : "#000000",
              colorLight : "#ffffff",
              correctLevel : QRCode.CorrectLevel.H
          });
        };
        // 在控制器初始化时生成二维码

      },
    ])
    .directive('ngScroll', ['$window', function($window) {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var scrollHandler = function() {
            var scrollTop = element[0].scrollTop;
            var scrollHeight = element[0].scrollHeight;
            var clientHeight = element[0].clientHeight;
            if (scrollTop + clientHeight >= scrollHeight - 10) { // 10 是一个缓冲区，可以根据需要调整
              scope.$apply(attrs.ngScroll);
            }
          };

          element.on('scroll', scrollHandler);

          scope.$on('$destroy', function() {
            element.off('scroll', scrollHandler);
          });
        }
      };
    }])
    .directive('pageScrollToBottom', ['$window', function($window) {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var windowEl = $window;
          var targetEl = element[0]; // ✅ 关键修正：提取原生元素
          var debounceTimeout = null;

          // ✅ 防抖函数：停止滚动 200ms 后执行检查
          function debounceCheck() {
            clearTimeout(debounceTimeout); // 清除之前的计时
            debounceTimeout = setTimeout(checkScroll, 200);
          }
          function checkScroll() {
            if (!targetEl || !targetEl.getBoundingClientRect) 
            {return;}
            // 空值保护
            var rect = targetEl.getBoundingClientRect();
            var elementBottom = rect.bottom + windowEl.pageYOffset;
            var scrollY = windowEl.pageYOffset;
            var viewHeight = windowEl.innerHeight;
            if (scrollY + viewHeight >= elementBottom - 50) {
              scope.$applyAsync(function() {
                scope.$eval(attrs.pageScrollToBottom);
              });
            }
          }
    
          // 监听事件改为
          angular.element(windowEl).on('scroll', debounceCheck);
          scope.$on('$destroy', function() {
            angular.element(windowEl).off('scroll', debounceCheck);
          });
        }
      };
    }]);
    
